import { Component, OnInit } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SpotComponent } from '../shared/spot/spot.component';
import { RevealDirective } from '../shared/reveal.directive';
import { DoodleComponent } from '../shared/doodle/doodle.component';
import {hasStoredToken} from '../../core/services/session-token';

interface ExampleRow {
  action: string;
  quills: number;
  inputWords: number | null;
}

interface Question {
  question: string;
  answer: string;
}

@Component({
    selector: 'app-pricing',
    templateUrl: './pricing.component.html',
    styleUrls: ['./pricing.component.scss'],
    imports: [RouterLink, DecimalPipe, SpotComponent, RevealDirective, DoodleComponent]
})
export class PricingComponent implements OnInit {

  /** Measured with Claude 3.5 Sonnet; kept as an illustration of how context grows per chapter. */
  readonly exampleRows: ExampleRow[] = [
    { action: 'Writing style', quills: 2, inputWords: null },
    { action: 'Background', quills: 2, inputWords: null },
    { action: '10 chapter summaries', quills: 3, inputWords: null },
    { action: 'Chapter 1', quills: 6, inputWords: 1726 },
    { action: 'Chapter 2', quills: 7, inputWords: 3186 },
    { action: 'Chapter 3', quills: 7, inputWords: 4687 },
    { action: 'Chapter 4', quills: 8, inputWords: 6078 },
    { action: 'Chapter 5', quills: 10, inputWords: 7646 },
    { action: 'Chapter 6', quills: 11, inputWords: 9487 },
    { action: 'Chapter 7', quills: 11, inputWords: 11214 },
    { action: 'Chapter 8', quills: 12, inputWords: 12676 },
    { action: 'Chapter 9', quills: 13, inputWords: 14176 },
    { action: 'Chapter 10', quills: 14, inputWords: 15789 }
  ];

  readonly exampleTotal = this.exampleRows.reduce((total, row) => total + row.quills, 0);
  readonly exampleMax = Math.max(...this.exampleRows.map(row => row.quills));

  readonly questions: Question[] = [
    {
      question: 'Do Quills expire?',
      answer: 'No. Quills you buy stay in your account until you use them, whether that is next week or next year.'
    },
    {
      question: 'Is there a subscription?',
      answer: 'No. There is no monthly fee and nothing renews. You top up when you need to.'
    },
    {
      question: 'How many Quills does a book take?',
      answer: 'It depends on the length of the book and the model you pick. The ten-chapter example above took 106 Quills, about a euro.'
    },
    {
      question: 'Why does each chapter cost a little more?',
      answer: 'Because the AI reads more of your story before it writes the next part. That is what keeps your characters and your plot consistent.'
    },
    {
      question: 'Can I spend less?',
      answer: 'Yes. Every model has its own rate, and you can switch to a cheaper one for any action. The estimate updates as you do.'
    }
  ];

  userIsLoggedIn = false;

  ngOnInit() {
    this.userIsLoggedIn = hasStoredToken();
  }

  barWidth(row: ExampleRow): string {
    return `${(row.quills / this.exampleMax) * 100}%`;
  }
}
